import api from '@/libs/api'
import store from '@/store'

const getProjectId = () => store.state.app.projectId

export default {
  namespaced: true,
  state: {
    sshKeys: [],
    resultInfo: {},
    currentPage: 1,
    fetchingSshKeys: false,
    sshKey: {},
    gettingSshKey: false,
    addingSshKey: false,
    updatingSshKey: false,
    removingSshKey: false,
  },
  getters: {
    currentPage: state => state.currentPage,
  },
  mutations: {
    SET_SSH_KEYS(state, value) {
      state.sshKeys = value.result
      state.resultInfo = value.resultInfo
    },
    SET_FETCHING_SSH_KEYS(state, value) {
      state.fetchingSshKeys = value
    },
    SET_SSH_KEY(state, value) {
      state.sshKey = value.result
    },
    SET_GETTING_SSH_KEY(state, value) {
      state.gettingSshKey = value
    },
    SET_ADDING_SSH_KEY(state, value) {
      state.addingSshKey = value
    },
    SET_UPDATING_SSH_KEY(state, value) {
      state.updatingSshKey = value
    },
    SET_REMOVING_SSH_KEY(state, value) {
      state.removingSshKey = value
    },
    REMOVE_SSH_KEY(state, id) {
      state.sshKeys = state.sshKeys.filter(el => el.id !== id)
    },
    SET_CURRENT_PAGE(state, value) {
      state.currentPage = value
    },
  },
  actions: {
    fetchSshKeys({ commit }, payload) {
      const ext = payload ? `?PageIndex=${payload.pageIndex}&PageSize=${payload.pageSize}` : ''
      commit('SET_FETCHING_SSH_KEYS', true)
      return new Promise((resolve, reject) => {
        api('compute')
          .get(`/projects/${getProjectId()}/ssh-keys${ext}`)
          .then(res => {
            commit('SET_SSH_KEYS', res.data)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_FETCHING_SSH_KEYS', false)
          })
      })
    },
    getSshKey({ commit }, id) {
      commit('SET_GETTING_SSH_KEY', true)
      return new Promise((resolve, reject) => {
        api('compute')
          .get(`/projects/${getProjectId()}/ssh-keys/${id}`)
          .then(res => {
            commit('SET_SSH_KEY', res.data)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_GETTING_SSH_KEY', false)
          })
      })
    },
    addSshKey({ commit }, sshKey) {
      commit('SET_ADDING_SSH_KEY', true)
      return new Promise((resolve, reject) => {
        api('compute')
          .post(`/projects/${getProjectId()}/ssh-keys`, sshKey)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_ADDING_SSH_KEY', false)
          })
      })
    },
    updateSshKey({ commit }, payload) {
      commit('SET_UPDATING_SSH_KEY', true)
      return new Promise((resolve, reject) => {
        api('compute')
          .put(`/projects/${getProjectId()}/ssh-keys/${payload.id}`, payload.key)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_UPDATING_SSH_KEY', false)
          })
      })
    },
    removeSshKey({ commit }, id) {
      commit('SET_REMOVING_SSH_KEY', true)
      return new Promise((resolve, reject) => {
        api('compute')
          .delete(`/projects/${getProjectId()}/ssh-keys/${id}`)
          .then(res => {
            commit('REMOVE_SSH_KEY', id)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_REMOVING_SSH_KEY', false)
          })
      })
    },
  },
}
